export const getIsPatreonUrl = (url: string): boolean =>
  url.includes('patreon.com')
